import { httpError, fetchGet, json } from 'common';
import { Dispatch } from 'redux';
const apiUri: string = process.env.REACT_APP_API_URI as string;

export const fetchMaintenanceMessage = (token: string, dispatch: Dispatch) =>
  fetchGet(`${apiUri}/appMessages/getmaintenancemessage`, token)
    .then(httpError(dispatch))
    .then(json);
